/**
 * 知识库文档「失败原因」的展示口径(0926 旅程冒烟)。
 *
 * 旧口径直接画 `errorMsg`,列表行出现过「ai ingest 调用失败: I/O error on POST request for
 * "http://127.0.0.1:9/…" Connection refused」—— 内部地址给租户看,且用户不知道该怎么办。
 * 现在 api 下发「原因码 + 人话」;只有带已知码的才信 `errorMsg`,其余(旧 api、存量原文、
 * UNKNOWN)一律兜底句。
 */
import { maskVendor } from "@/shared/lib/vendorMask";

export const KB_FAILURE_FALLBACK = "未知原因,请重试或联系技术支持";

export interface KbFailureSource {
  status?: string | null;
  errorMsg?: string | null;
  errorCode?: string | null;
}

/** 非 failed → null(done 行的陈年残留不画);failed → 人话。 */
export function kbFailureText(doc: KbFailureSource): string | null {
  if (doc.status !== "failed") return null;
  const code = doc.errorCode?.trim();
  const msg = doc.errorMsg?.trim();
  if (code && code !== "UNKNOWN" && msg) return maskVendor(msg);
  return KB_FAILURE_FALLBACK;
}
